import React from 'react';
import styled from 'styled-components';
import * as BuilderUI from '../BuilderUI';
import {
  IRowMeta,
  setSelectedPartitionAction,
} from '../../../redux/slices/oldBuilder';
import GlobalPartition from './GlobalPartition';
import StepPartition from './StepPartition';
import {
  FunnelModeKey,
  IPartitionValueFieldsFragment,
  QueryType,
} from '../../../utils/apollo/graphqlSchema';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import {
  builderDefaultOptionsSelector,
  builderSelectedOptionsSelector,
} from '../../../redux/selectors/builder';
import KubitTooltip from '../../KubitTooltip';
import {
  funnelPartitionTooltipOption,
  pathPartitionTooltipOption,
} from '../../KubitTooltip/globalTooltips';
import { assertCondition } from '../../../utils/types';

interface IProps {
  queryType: QueryType.Funnel | QueryType.Path;
  rowMeta?: IRowMeta;
}

const Container = styled(BuilderUI.BuilderFieldContainer)`
  flex-shrink: 1;
`;

export default ({ queryType, rowMeta }: IProps) => {
  const dispatch = useAppDispatch();

  const defaultOptions = useAppSelector((state) =>
    builderDefaultOptionsSelector(state),
  );
  const selectedOptions = useAppSelector((state) =>
    builderSelectedOptionsSelector(state),
  );

  assertCondition(
    defaultOptions?.type === queryType && selectedOptions?.type === queryType,
  );

  const globalPartitionOptions = defaultOptions.partitions;
  const globalPartitionValues = selectedOptions.partitionValues;

  const selectedFunnelMode =
    selectedOptions.type === QueryType.Funnel ? selectedOptions.mode : null;

  const setPartitionValue = (value: IPartitionValueFieldsFragment) => {
    dispatch(
      setSelectedPartitionAction({
        value,
      }),
    );
  };

  const tooltipOption =
    queryType === QueryType.Path
      ? pathPartitionTooltipOption
      : funnelPartitionTooltipOption;

  return (
    <Container>
      <KubitTooltip {...tooltipOption} noOpenDelay={true}>
        <BuilderUI.BuilderFieldLabel>
          {rowMeta ? 'Converted within' : 'Partition'}
        </BuilderUI.BuilderFieldLabel>
      </KubitTooltip>

      {!rowMeta ? (
        <GlobalPartition
          setPartitionValue={setPartitionValue}
          selectedPartitions={globalPartitionValues}
          availablePartitions={globalPartitionOptions}
          isTimeToConvertMode={
            selectedFunnelMode === FunnelModeKey.TimeToConvert
          }
        />
      ) : (
        <StepPartition rowMeta={rowMeta} />
      )}
    </Container>
  );
};
